import { aiInRecruitingFutureSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingFutureSection.module.css'

const ArrowIcon = () => (
  <svg
    className={styles.arrowIcon}
    width="21"
    height="12"
    viewBox="0 0 21 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 5.77356L11 5.67436e-05V11.5471L21 5.77356ZM0 5.77356V6.77356H12V5.77356V4.77356H0V5.77356Z"
      fill="#FF952B"
    />
  </svg>
)

const AiInRecruitingFutureSection = () => {
  const { title, subtitle, trendsLabel, items } =
    aiInRecruitingFutureSectionData

  return (
    <section className={styles.futureSection}>
      <div className="container">
        <h2 className={styles.sectionTitle}>{title}</h2>
        <p className={styles.sectionSubtitle}>{subtitle}</p>
        <p className={styles.trendsLabel}>{trendsLabel}</p>
        <div className={styles.listBox}>
          {items.map((item, i) => (
            <div key={i} className={styles.listItem}>
              <ArrowIcon />
              <p className={styles.itemText}>
                <span className={styles.itemLabel}>{item.label}</span>
                {'  '}
                <span className={styles.itemDesc}>{item.description}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingFutureSection
